import { Form } from '@kanda-libs/ks-component-ts';
import useApplyForm from './useApplyForm';

interface ApplyFormProps {
  children: JSX.Element;
}

const ApplyForm = ({ children }: ApplyFormProps) => (
  <Form {...useApplyForm()} id="apply-form-finance">
    {children}
  </Form>
);

export default ApplyForm;
